import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '@env/environment';
import { Logger } from '../logger.service';
import { GlobalEventsService } from '@app/global-events.service';
import { AnalyticsService } from '@app/ahoy-analytics/analytics.service';

const log = new Logger('ErrorHandlerInterceptor');

/**
 * Adds a default error handler to all requests.
 */
@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(
    private globalEventsService: GlobalEventsService,
    private analytics: AnalyticsService,
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next
      .handle(request)
      .pipe(catchError((error) => this.errorHandler(error, request)));
  }

  // Customize the default error handler here if needed
  private errorHandler(
    response: HttpErrorResponse,
    request: HttpRequest<unknown>,
  ): Observable<HttpEvent<unknown>> {
    this.analytics.trackApiError(request, response);

    if (response.status === 451) {
      this.globalEventsService.onPromotToAcceptTerms.emit();
    }
    if (!environment.production) {
      log.error('Request error', response);
    }

    // AI assistant 403 means "feature not allowed" and is handled inline by the chatbot
    if (response.status === 403 && !request.url.includes('/ai-assistant/')) {
      this.globalEventsService.onUnauthorizedException();
    }
    return throwError(response);
  }
}
